export const ROLE_AGENT = 'agent';
export const ROLE_DISTRIBUTOR = 'distributor';
export const ROLE_TECHINICIAN = 'technician';
export const ROLE_USER = 'user';

export const ROLE_ID = {
  ADMIN: 1,
  PROVINCE: 3,
  WARD: 4,
  WEARER: 6,
  CENTRAL: 11,
} as const;
